import React from "react";
import { TextField, TextFieldProps } from "@material-ui/core";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import { LocalizationContext } from "../../../core/localization/Localization";

interface AutocompleteSelectProps<T> {
	selected?: T | null;
	onChangeItem: (newValue: T | null) => void;
	predicate?: (value: T) => boolean;
	dataFilter?: (value: T) => boolean;
	data?: T[];
	getLabel: (data: T) => string;
	errorMessage?: string;
}

export type AutocompleteSelectType<T> = AutocompleteSelectProps<T> & TextFieldProps;

export function AutocompleteSelect<T>({
	selected,
	onChangeItem,
	predicate,
	data,
	getLabel,
	error,
	errorMessage,
	disabled,
	dataFilter,
	...otherProps
}: AutocompleteSelectType<T>) {
	const { getString } = React.useContext(LocalizationContext);

	const handleCityChange = React.useCallback(
		(event: any, newValue: T | null) => {
			if (onChangeItem) {
				onChangeItem(newValue);
			}
		},
		[onChangeItem]
	);

	const helperText = React.useMemo(
		() => (error ? errorMessage || getString("requiredMessage") : undefined),
		[getString, error, errorMessage]
	);

	const filtredData = React.useMemo(() => {
		return (dataFilter && data && data.filter(dataFilter)) || data;
	}, [dataFilter, data]);

	const selectedItem = React.useMemo(() => {
		return selected || (predicate && filtredData && filtredData.find(predicate)) || null;
	}, [selected, predicate, filtredData]);


	if (!filtredData) {
		return <Skeleton variant="text" width={"100%"} />;
	}

	return (
		<Autocomplete<T>
			options={filtredData}
			getOptionLabel={getLabel}
			value={selectedItem}
			onChange={handleCityChange}
			disabled={disabled}
			renderInput={params => (
				<TextField {...params} error={error} helperText={helperText} {...otherProps} />
			)}
		/>
	);
}
